
export default {
  data() {
    return {
      isVisible: false,
      isAbsolute: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      const footer = document.querySelector(".footer-container");
      const footerHeight = parseInt(window.getComputedStyle(footer).height.split('px')[0]);
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.scrollHeight;
      const scrollPosition = window.scrollY + windowHeight;
      
      this.isVisible = window.scrollY > 300
      this.isAbsolute = scrollPosition > documentHeight - footerHeight;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
  },
}
